var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Workers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgii",
    x1: 11.974,
    x2: 15.321,
    y1: 541.931,
    y2: 530.417,
    xlinkHref: "#84fpxElyGcc98urKkfxgic"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgic",
    x1: 30.974,
    x2: 34.321,
    y1: 546.931,
    y2: 535.417,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 11",
    gradientTransform: "matrix(1 0 0 -1 0 572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0370c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#036fc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#036abd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0362b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgig",
    x1: -11.354,
    x2: -10.354,
    gradientTransform: "rotate(180 7.792 286)",
    xlinkHref: "#84fpxElyGcc98urKkfxgia"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgio",
    x1: 7.279,
    x2: 7.657,
    y1: 38.277,
    y2: 36.092,
    xlinkHref: "#84fpxElyGcc98urKkfxgib"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgin",
    x1: 13.516,
    x2: 15.322,
    y1: 42.568,
    y2: 32.114,
    xlinkHref: "#84fpxElyGcc98urKkfxgif"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgif",
    x1: 32.516,
    x2: 34.322,
    y1: 37.568,
    y2: 27.114,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 5",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgib",
    x1: 26.279,
    x2: 26.657,
    y1: 33.277,
    y2: 31.092,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 8",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgih",
    x1: 40.279,
    x2: 40.657,
    y1: 33.277,
    y2: 31.092,
    xlinkHref: "#84fpxElyGcc98urKkfxgib"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgia",
    x1: 40.063,
    x2: 41.063,
    y1: 554.5,
    y2: 554.5,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 10",
    gradientTransform: "matrix(1 0 0 -1 0 572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgij",
    x1: 21.063,
    x2: 22.063,
    y1: 549.5,
    y2: 549.5,
    xlinkHref: "#84fpxElyGcc98urKkfxgia"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgik",
    x1: 7.646,
    x2: 8.646,
    y1: 549.5,
    y2: 549.5,
    gradientTransform: "rotate(180 7.792 286)",
    xlinkHref: "#84fpxElyGcc98urKkfxgia"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84fpxElyGcc98urKkfxgip",
    x1: 21.279,
    x2: 21.657,
    y1: 38.277,
    y2: 36.092,
    xlinkHref: "#84fpxElyGcc98urKkfxgib"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "84fpxElyGcc98urKkfxgil",
    cx: 123.354,
    cy: 481.893,
    r: 8.82,
    xlinkHref: "#84fpxElyGcc98urKkfxgid"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "84fpxElyGcc98urKkfxgim",
    cx: 116.305,
    cy: 485.707,
    r: 18.36,
    xlinkHref: "#84fpxElyGcc98urKkfxgie"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "84fpxElyGcc98urKkfxgie",
    cx: 137.856,
    cy: 491.201,
    r: 18.36,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 7",
    gradientTransform: "matrix(.8816 0 0 -.91004 -94.25 460.477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "84fpxElyGcc98urKkfxgid",
    cx: 144.906,
    cy: 487.564,
    r: 8.82,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 9",
    gradientTransform: "matrix(.8816 0 0 -.8816 -94.25 446.962)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgic)",
    d: "M33.5,25.50859c-6.90391,0-12.5,3.84454-12.5,8.03594v.893A1.56207,1.56207,0,0,0,22.5625,36h21.875A1.56207,1.56207,0,0,0,46,34.4375v-.893C46,29.35313,40.40391,25.50859,33.5,25.50859Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M37.01155,26.94076C37.01155,28.273,35.60693,29.75,33.5,29.75s-3.51155-1.477-3.51155-2.80924V22h7.0231Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgia)",
    d: "M40.062,16h-.39525v3H40.194a.76538.76538,0,0,0,.78075-.555l.258-1.27725A1.06828,1.06828,0,0,0,40.062,16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgig)",
    d: "M26.938,16h.39525v3H26.806a.76538.76538,0,0,1-.78075-.555l-.258-1.27725A1.06828,1.06828,0,0,1,26.938,16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgid)",
    d: "M33.5,8.25c-3.20438,0-6.4939.487-6.4939,7.41387v4.83291C27.0061,22.96951,30.90244,26,33.5,26s6.4939-3.03049,6.4939-5.50322V15.66387C39.9939,8.737,36.70438,8.25,33.5,8.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgie)",
    d: "M26.23437,13a37.45772,37.45772,0,0,0,.72657,6l1.45312-6H38.58594s1.45312,5.226,1.45312,6a40.74787,40.74787,0,0,0,.72656-6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6900",
    d: "M40.88636,13.27273v-.72728A6.59677,6.59677,0,0,0,34.23864,6H32.76136a6.59678,6.59678,0,0,0-6.64773,6.54545v.72728A.73328.73328,0,0,1,25.375,14h16.25A.73329.73329,0,0,1,40.88636,13.27273Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff832b",
    d: "M42.125,16H24.875c-.207,0-.375-.224-.375-.5v-1c0-.276.168-.5.375-.5h17.25c.207,0,.375.224.375.5v1C42.5,15.776,42.332,16,42.125,16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc720f",
    d: "M32.75,5h1.5a.75027.75027,0,0,1,.75.75V14H32V5.75A.75027.75027,0,0,1,32.75,5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgif)",
    d: "M39,26.37V33H28V26.37a13.98116,13.98116,0,0,0-3,1.37V36H42V27.74A13.98116,13.98116,0,0,0,39,26.37Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 25,
    y: 31,
    fill: "url(#84fpxElyGcc98urKkfxgib)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 39,
    y: 31,
    fill: "url(#84fpxElyGcc98urKkfxgih)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgii)",
    d: "M14.5,30.50859c-6.90391,0-12.5,3.84454-12.5,8.03594v.893A1.56207,1.56207,0,0,0,3.5625,41h21.875A1.56207,1.56207,0,0,0,27,39.4375v-.893C27,34.35313,21.40391,30.50859,14.5,30.50859Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M18.01155,31.94076C18.01155,33.273,16.60693,34.75,14.5,34.75s-3.51155-1.477-3.51155-2.80924V27h7.0231Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgij)",
    d: "M21.062,21h-.39525v3H21.194a.76538.76538,0,0,0,.78075-.555l.258-1.27725A1.06828,1.06828,0,0,0,21.062,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgik)",
    d: "M7.938,21h.39525v3H7.806a.76538.76538,0,0,1-.78075-.555l-.258-1.27725A1.06828,1.06828,0,0,1,7.938,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgil)",
    d: "M14.5,13.25c-3.20438,0-6.4939.487-6.4939,7.41387v4.83291C8.0061,27.96951,11.90244,31,14.5,31s6.4939-3.03049,6.4939-5.50322V20.66387C20.9939,13.737,17.70438,13.25,14.5,13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgim)",
    d: "M7.23437,18a37.45772,37.45772,0,0,0,.72657,6l1.45312-6H19.58594s1.45312,5.226,1.45312,6a40.74787,40.74787,0,0,0,.72656-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc6900",
    d: "M21.88636,18.27273v-.72728A6.59677,6.59677,0,0,0,15.23864,11H13.76136a6.59678,6.59678,0,0,0-6.64773,6.54545v.72728A.73328.73328,0,0,1,6.375,19h16.25A.73329.73329,0,0,1,21.88636,18.27273Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff832b",
    d: "M23.125,21H5.875c-.207,0-.375-.224-.375-.5v-1c0-.276.168-.5.375-.5h17.25c.207,0,.375.224.375.5v1C23.5,20.776,23.332,21,23.125,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc720f",
    d: "M13.75,10h1.5a.75027.75027,0,0,1,.75.75V19H13V10.75A.75027.75027,0,0,1,13.75,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#84fpxElyGcc98urKkfxgin)",
    d: "M20,31.37V38H9V31.37a13.98116,13.98116,0,0,0-3,1.37V41H23V32.74A13.98116,13.98116,0,0,0,20,31.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 6,
    y: 36,
    fill: "url(#84fpxElyGcc98urKkfxgio)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 20,
    y: 36,
    fill: "url(#84fpxElyGcc98urKkfxgip)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Workers);
export default __webpack_public_path__ + "static/media/icons8-workers.1669ad60e28e264ae14a465b58a8e2e2.svg";
export { ForwardRef as ReactComponent };